import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Currency } from '@/types';
import { useGetCurrenciesQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchCurrencies<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Currency> } & Omit<
  AutocompleteProps<Currency, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetCurrenciesQueryProps = useAsyncSearch<Currency, Multiple, DisableClearable, FreeSolo>(
    useGetCurrenciesQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetCurrenciesQueryProps} />;
}

export default SearchCurrencies;
